import { type I18n, type Composer, createI18n } from "vue-i18n";

import { LocalStorageService } from "@/Services/LocalStorageService";
import { Language } from "@/Common/Models/Domain/Language";

import { isValidLanguage } from "@/Utils/Language";

import en from "@/Plugins/i18n/locales/en.json";
import es from "@/Plugins/i18n/locales/es.json";
import it from "@/Plugins/i18n/locales/it.json";
import pt from "@/Plugins/i18n/locales/pt.json";

export interface LocalI18n extends I18n {
  global: Composer;
}

export const LANG_STORAGE_KEY = "lang";
export type MessageSchema = typeof en;
const messages = { en, es, it, pt };

const localStorageService = new LocalStorageService("i18n");
const localStorageLang: string = localStorageService.get(LANG_STORAGE_KEY);
let lang = localStorageLang ? localStorageLang : navigator.language.substring(0, 2);

if (!isValidLanguage(lang)) {
  lang = "en";
}

export default createI18n<[MessageSchema], Language>({
  legacy: false,
  globalInjection: true,
  locale: lang || "en",
  fallbackLocale: "en",
  messages,
}) as unknown as LocalI18n;
